<div class="container-fluid">
  <!-- loader -->
  <div *appLoading></div>
  <app-header></app-header>
  <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
  <app-menu></app-menu>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
